module.exports = __webpack_public_path__ + "static/media/1.1dc60849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16008/1.jpg
// module id = 501
// module chunks = 0